//@flow
import {useSelector} from 'react-redux';

import {actions as ReviewsAction} from './duck';
import type {RootState} from '../../../modules';
import {useEffect} from 'react';
import {useActions} from '../../../utils/globalStore';

const storeReviewsSelector = (state: RootState) => state.reviews.reviews;

export function useStoreReviews() {
  const storeReviews = useSelector(storeReviewsSelector);

  const fetchReviews = useActions(ReviewsAction.fetchReviews);

  useEffect(() => {
    if (!storeReviews) {
      fetchReviews();
    }
  }, [fetchReviews, storeReviews]);

  return storeReviews;
}
